export const PLACEMENT = 'reset-password'
export const NEW_PASSWORD = 'new-password'
export const CONFIRM_PASSWORD = 'confirm-password'

export const PASSWORD_MIN = 12
export const PASSWORD_MAX = 64

export const PASSWORD_RULE = [
    {
        required: true,
        message: 'Password required',
    },
    {
        min: PASSWORD_MIN,
        message: `Password must be minimum ${PASSWORD_MIN} characters.`,
    },
    {
        max: PASSWORD_MAX,
        message: `Password cannot exceed max ${PASSWORD_MAX} characters.`,
    },
]

export const NO_FEEDBACK_PASSWORD_RULE = PASSWORD_RULE.map(rule => ({
    ...rule,
    message: undefined,
}))
